module.exports = __webpack_public_path__ + "static/media/COS_GARANCIA.2085435f.webp";